import { SocialSharingActions } from '@rocco/ui/social-sharing/components/SocialSharingActions';
import { ClientOnly } from 'remix-utils';

import type { Platform } from '@rocco/ui/social-sharing/utils/platform';
import type { DisplayMode } from '@rocco/types/enum/display-mode';
import {
    shareNative,
    shareContent,
    type ShareOptions,
    isNativeShareAvailable,
} from '../utils/sharing';
import { useTracker } from '@archipro-website/tracker';
import { capitalizeFirstLetter } from '../../../utils/stringHelper';
interface SocialShareInitializerProps {
    displayMode: DisplayMode;
}

export const SocialShareInitializer = ({
    displayMode,
}: SocialShareInitializerProps) => {
    const tracker = useTracker();
    const onShare = (platform: Platform) => {
        // Get Open Graph metadata from meta tags
        const getMetaContent = (property: string): string => {
            const metaTag =
                document.querySelector(`meta[property="${property}"]`) ||
                document.querySelector(`meta[name="${property}"]`);
            return metaTag ? metaTag.getAttribute('content') || '' : '';
        };

        // use Open Graph metadata if available, otherwise use the current page
        const opts: ShareOptions = {
            url: getMetaContent('og:url') || window.location.href,
            title: getMetaContent('og:title') || window.document.title,
            description:
                getMetaContent('og:description') ||
                getMetaContent('description'),
        };

        if (displayMode === 'mobile') {
            // Try native share if available, otherwise fall back to copy link
            if (isNativeShareAvailable()) {
                shareNative(opts);
                tracker.log('ShareSubmit', {
                    url: new URL(window.location.href),
                    data: {
                        ExtraData: 'NativeShare',
                    },
                });
            } else {
                // Fall back to copy link if native sharing is not supported
                shareContent('copy', opts);
            }
        } else {
            shareContent(platform, opts);
        }
    };

    return (
        <ClientOnly>
            {() => (
                <>
                    <SocialSharingActions
                        displayMode={displayMode}
                        onShare={onShare}
                        trackingConfig={{
                            onOpen: () => {
                                tracker.log('ShareReveal', {
                                    url: new URL(window.location.href),
                                });
                            },
                            onShare: (platform) => {
                                tracker.log('ShareSubmit', {
                                    url: new URL(window.location.href),
                                    data: {
                                        ExtraData:
                                            capitalizeFirstLetter(platform),
                                    },
                                });
                            },
                        }}
                    />
                </>
            )}
        </ClientOnly>
    );
};
